export const typeColors = {
  grass: "rgba(120, 200, 79, 0.4)",
  fire: "rgba(240, 128, 48, 0.4)",
  water: "rgba(104, 144, 240, 0.4)",
  electric: "rgba(249, 208, 48, 0.4)",
  flying: "rgba(169, 143, 243, 0.4)",
  normal: "rgba(167, 168, 119, 0.4)",
  ghost: "rgba(112, 89, 152, 0.4)",
  ice: "rgba(150, 217, 214, 0.4)",
  fighting: "rgba(194, 46, 40, 0.4)",
  poison: "rgba(163, 62, 161, 0.4)",
  ground: "rgba(226, 191, 101, 0.4)",
  psychic: "rgba(249, 85, 135, 0.4)",
  bug: "rgba(166, 185, 26, 0.4)",
  rock: "rgba(182, 161, 54, 0.4)",
  dark: "rgba(112, 87, 70, 0.4)",
  dragon: "rgba(111, 53, 252, 0.4)",
  steel: "rgba(183, 183, 206, 0.4)",
  fairy: "rgba(214, 133, 173, 0.4)",
  hover: {
    grass: "rgba(120, 200, 79, 0.6)",
    fire: "rgba(240, 128, 48, 0.6)",
    water: "rgba(104, 144, 240, 0.6)",
    electric: "rgba(249, 208, 48, 0.6)",
    flying: "rgba(169, 143, 243, 0.6)",
    normal: "rgba(167, 168, 119, 0.6)",
    ghost: "rgba(112, 89, 152, 0.6)",
    ice: "rgba(150, 217, 214, 0.6)",
    fighting: "rgba(194, 46, 40, 0.6)",
    poison: "rgba(163, 62, 161, 0.6)",
    ground: "rgba(226, 191, 101, 0.6)",
    psychic: "rgba(249, 85, 135, 0.6)",
    bug: "rgba(166, 185, 26, 0.6)",
    rock: "rgba(182, 161, 54, 0.6)",
    dark: "rgba(112, 87, 70, 0.6)",
    dragon: "rgba(111, 53, 252, 0.6)",
    steel: "rgba(183, 183, 206, 0.6)",
    fairy: "rgba(214, 133, 173, 0.6)",
  },
};

export const solidColors = {
  light: {
    grass: "#c1e1b1",
    fire: "#f1c4a4",
    water: "#bbcbf1",
    electric: "#f5e4a4",
    flying: "#d5caf2",
    normal: "#d4d4c1",
    ghost: "#beb5ce",
    ice: "#cde8e7",
    fighting: "#dfa3a1",
    poison: "#d2aad1",
    ground: "#ebddb9",
    psychic: "#f5b3c7",
    bug: "#d3db9b",
    rock: "#dad1a7",
    dark: "#beb4ad",
    dragon: "#bda6f6",
    steel: "#dadae3",
    fairy: "#e7c6d6",
  },
  dark: {
    grass: "#617f59",
    fire: "#8b664e",
    water: "#5c6c91",
    electric: "#8f824e",
    flying: "#736b92",
    normal: "#717367",
    ghost: "#5e5871",
    ice: "#6c8587",
    fighting: "#7c494b",
    poison: "#704f75",
    ground: "#867b60",
    psychic: "#8f576c",
    bug: "#717a46",
    rock: "#777150",
    dark: "#5e5755",
    dragon: "#5d4b95",
    steel: "#777985",
    fairy: "#826779",
  },
};
